import React, { useState, useRef, useEffect } from "react";
import "./util.css";
import { toast } from "react-toastify";

import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import FormHelperText from "@mui/material/FormHelperText";
import dayjs from "dayjs";
import { ThemeProvider } from "@mui/material/styles";
import { DateTimePickerTheme } from "./theme";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Accordion, AccordionDetails, AccordionSummary, Chip, FormLabel, MenuList, Slide } from "@mui/material";
import MuiButton from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import MuiDrawer from "@mui/material/Drawer";
import MuiCheckbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Popover from "@mui/material/Popover";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { alpha, styled } from "@mui/material/styles";
import colorPicker from "../../Images/colorPicker.png";
import { ArrowDownIcon, CloseIcon, EyeCloseIcon, EyeIcon, UploadIcon, ColorIcon, ExpandMoreIcon, DragIndicatorIcon } from "../../services/icons";
import MuiRadio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TableMui from "./GenericTable";
import no_data_found from "../../Images/no_data_found.svg";
import loader from "../../Images/loader.gif";
import theme, { inputClasses, buttonClasses, textClasses, cardClasses, autocompleteTheme } from "./theme";
import { capitalizeCamelCase, debounce, fakeFileInput } from "../../services/functions";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./util.css";
import { includes_special_char } from "../../services/validation";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import PhoneInput, { isSupportedCountry } from "react-phone-number-input/input";
const loaderSvg = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
			<path
				fill="var(--gray-color)"
				d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"
			>
				<animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
			</path>
		</svg>
	);
};

const adornmentIcon = {
	eyeClose: <EyeCloseIcon />,
	eye: <EyeIcon />,
	CloseIcon: <CloseIcon sx={{ fontSize: "1rem" }} />,
	loader: loaderSvg(),
	UploadIcon: <UploadIcon />,
};

const CustomSwitch = styled(Switch)(({ theme }) => ({
	"& .MuiSwitch-switchBase.Mui-checked": {
		color: "var(--primary-color)",
		"&:hover": {
			backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
		},
	},
	"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
		backgroundColor: "var(--primary-color)",
	},
}));
// const TCell = ({ text = "-", color = "", cursor = "", onClick }) => {
// 	<Typography
// 		sx={{
// 			...textClasses.t13n,
// 			textAlign: "center",
// 			color,
// 			cursor,
// 		}}
// 	>
// 		{text}
// 	</Typography>;
// };

function ActionMenu({
    id,
    handlers = {},
    childMenuOpen = [],
    childMenu = {},
    handleChildMenuClick,
	loading = false,
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorSubMenu, setAnchorSubMenu] = useState(null);
    const [activeSubMenuKey, setActiveSubMenuKey] = useState(null);

    const open = Boolean(anchorEl);
    const menuSx = {
      "& .MuiPaper-root": {
        backgroundColor: "var(--model-bg-color)",
        color: "var(--text-color)",
        border: "1px solid var(--input-border-color)",
      },
      "& .MuiMenu-list": {
        padding: "4px 0",
        maxHeight: "400px",
      },
      "& .MuiMenuItem-root": {
        color: "var(--text-color)",
      },
      "& .MuiMenuItem-root:hover": {
        backgroundColor: "var(--option-hover-color)",
      },
    };

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setAnchorSubMenu(null);
        setActiveSubMenuKey(null);
    };

    return (
      <div className="actionMenu">
        {tCell("Action", theme.themeOrange, "pointer", handleClick)}

        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={menuSx}>
			{Object.keys(handlers).map((key) => {
				const hasSubMenu = childMenuOpen.includes(key);
				const isActive = activeSubMenuKey === key;

				return (
				<MenuItem
					key={key}
					onClick={(e) => {
					handlers[key](id);

					if (hasSubMenu) {
						e.stopPropagation();
						setActiveSubMenuKey(key);
						setAnchorSubMenu(e.currentTarget);
					} else {
						handleClose();
					}
					}}
					
				>
					{/* LEFT ARROW FOR SUBMENU */}
					{hasSubMenu && (
					<KeyboardArrowLeftIcon
						fontSize="small"
						sx={{
						marginLeft: "-15px",
						opacity: isActive ? 1 : 0.6,
						}}
					/>
					)}
					<span style={!hasSubMenu ? {paddingLeft : "4px"} : {}}>{capitalizeCamelCase(key)}</span>
				</MenuItem>
				);
			})}
		</Menu>

        {/* SUB MENU */}
        {loading ? (
          <Menu
            anchorEl={anchorSubMenu}
            open={Boolean(anchorSubMenu)}
            onClose={handleClose}
            sx={menuSx}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left", // Corrected
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem disabled>Loading...</MenuItem>
          </Menu>
        ) : (
          childMenu?.[activeSubMenuKey]?.length > 0
              ? <Menu
            anchorEl={anchorSubMenu}
            open={Boolean(anchorSubMenu)}
            onClose={handleClose}
            sx={menuSx}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left", // Corrected
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {childMenu[activeSubMenuKey].map((item) => (
                  <MenuItem
                    key={item.label}
                    onClick={() => {
                      handleChildMenuClick({
                        ...item,
                        index: id,
                        parent: activeSubMenuKey,
                      });
                      handleClose();
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))
            }
          </Menu> : null
        )}
      </div>
    );
}
function Switcher({ id, name, checked = false, onChange, label = "", disabled = false, readOnly = false, size = "small", value = "" }) {
	return (
		<span className="UM_switch-container">
			<CustomSwitch disabled={disabled} size={size} checked={checked} onChange={onChange} name={name} inputProps={{ "aria-label": "controlled" }} />
			<label className="labeltext">{label}</label>
		</span>
	);
}
function Button({ onClick, testId, variant = "contained", disabled = false, text, style = {}, type = "button", children }) {
	return (
		<MuiButton
			className="UM_uploadfile-btn"
			sx={{
				width: "100%",
				...style,
				textTransform: "none",
				cursor: disabled ? "not-allowed !important" : "",
				pointerEvents: disabled ? "all !important" : "",
				"&.Mui-disabled": {
					color: "var(--button-disabled-text-color)",
					WebkitTextFillColor: "var(--button-disabled-text-color)",
				},
			}}
			size="small"
			variant={variant}
			data-testid={testId}
			disabled={disabled}
			onClick={onClick}
			type={type}
		>
			{text}
			{children}
		</MuiButton>
	);
}
function Checkbox({ id, name, checked = false, onChange, label = "", disabled = false, readOnly = false, size = "small", value = "", error = "" }) {
	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<FormControlLabel
				control={
					<MuiCheckbox
						disabled={disabled}
						size={size}
						checked={checked}
						onChange={onChange}
						value={value}
						name={name}
						sx={{
							...inputClasses.checkbox,
							...(error ? { color: "error.main" } : {}),
						}}
					/>
				}
				label={<Typography style={{ wordBreak: "break-all" }}>{label}</Typography>}
				style={{ color: "var(--text-color)" }}
			/>
			{error && (
				<Typography variant="caption" color="error">
					{error}
				</Typography>
			)}
		</div>
	);
}

function PopOver({ children, id, title, anchorEl, open, onClose, placement = "bottom", width, height, titleFontSize, contentFontSize }) {
	const handleClose = () => {
		document.activeElement.blur(); // to prevent from the console error aria-label
		if (onClose) {
			onClose();
		}
	};

	return (
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			disableAutoFocus
			slotProps={{
				paper: {
					sx: {
						width: width || "auto",
						height: height || "auto",
						overflow: "hidden",
						backgroundColor: "var(--background-color)",
						color: "var(--text-color)",
						border: "1px solid var(--table-header-bg-color)",
					},
				},
			}}
		>
			<Box
				sx={{
					p: 2,
					width: "100%",
					height: "100%",
					boxSizing: "border-box",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<Typography variant="h6" gutterBottom style={{ fontSize: titleFontSize }}>
						{title}
					</Typography>
					<IconButton
						onClick={handleClose}
						size="small"
						sx={{
							marginLeft: 2,
							marginBottom: 1,
							color: "var(--text-color)"
						}}
						aria-label="Close popover"
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box sx={{ flex: 1, overflow: "auto", fontSize: contentFontSize }}>{children}</Box>
			</Box>
		</Popover>
	);
}

function DataNotFound({text="No Data Found"}) {
	return (
		<>
			<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
				<img src={no_data_found} height="250px" width="250px" />
				<Typography sx={{ color: "var(--text-color)" }}>{text}</Typography>
			</Box>
		</>
	);
}
function DatePicker({ name, label, value, minDATE, maxDATE, onChange, disabled = false, isRequired = false, format = "DD/MM/YYYY" }) {
	return (
		<ThemeProvider theme={DateTimePickerTheme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<MuiDatePicker
					className="customDatePicker"
					sx={{ ...inputClasses.shadowField, fontSize: "8px", width: "100%" }}
					slotProps={{ textField: { size: "small" } }}
					format={format}
					name={name}
					value={value}
					onChange={onChange}
					label={label}
					disabled={disabled}
					minDate={minDATE}
					maxDate={maxDATE}
					isRequired={isRequired}
				/>
			</LocalizationProvider>
		</ThemeProvider>
	);
}

function DatePickerOfMonth({ name, label, value, minDATE, maxDATE, onChange, disabled = false, isRequired = false, format = "MM/YYYY", views }) {
	return (
		<ThemeProvider theme={DateTimePickerTheme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<MuiDatePicker
					className="customDatePicker"
					sx={{ ...inputClasses.shadowField, fontSize: "8px", width: "100%" }}
					slotProps={{ textField: { size: "small" } }}
					format={format}
					name={name}
					value={value}
					onChange={onChange}
					label={label}
					disabled={disabled}
					minDate={minDATE}
					maxDate={maxDATE}
					isRequired={isRequired}
					views={views}
				/>
			</LocalizationProvider>
		</ThemeProvider>
	);
}
function TimePicker({ name, label, value, onChange, disabled = false, isRequired = false }) {
	return (
		<ThemeProvider theme={DateTimePickerTheme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<MuiTimePicker
					className="customTimePicker"
					sx={{ ...inputClasses.shadowField, fontSize: "8px", width: "100%" }}
					slotProps={{ textField: { size: "small" } }}
					name={name}
					value={value}
					onChange={onChange}
					label={label}
					disabled={disabled}
					timeSteps={{ minutes: 1 }}
					isRequired={isRequired}
				/>
			</LocalizationProvider>
		</ThemeProvider>
	);
}
function DateTimePicker({ disabled = false, label, name, onChange, value, minDATE, maxDATE }) {
	// const maxDate = dayjs(new Date()).format('YYYY-MM-DD');
	// const minDate = minDATE ? dayjs(minDATE).format('YYYY-MM-DD') : null;
	const today = dayjs("2024-04-09T18:30:00.000Z");
	return (
		<ThemeProvider theme={DateTimePickerTheme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<MuiDateTimePicker
					disabled={disabled}
					label={label}
					name={name}
					onChange={onChange}
					size="small"
					sx={{ ...inputClasses.shadowField }}
					slotProps={{ textField: { size: "small" } }}
					value={dayjs(value)}
					minDate={minDATE}
					maxDate={maxDATE}
					// disableFuture
					// maxDate={new Date()}
				/>
			</LocalizationProvider>
		</ThemeProvider>
	);
}

function DetailCard({ isOpen, onClose, title, children, height = "" }) {
	return (
		<div className={`detail_card ${isOpen ? "open" : ""}`}>
			{isOpen && (
				<Card sx={{ ...cardClasses.basic, borderRadius: "8px", border: `1px solid ${theme.themeOrange}` }}>
					<CardHeader
						sx={{ height: "46px", backgroundColor: theme.themeOrange }}
						title={
							<Typography
								sx={{
									...textClasses.boldText,
									color: "white",
									fontSize: "16px",
								}}
							>
								{title}
							</Typography>
						}
						action={
							<IconButton size="small" sx={{ p: 0, mb: 1 }} onClick={onClose}>
								<CloseIcon sx={{ color: "white" }} />
							</IconButton>
						}
					/>
					<CardContent sx={{ height: height || "55vh", overflowY: "auto", overflowX: "hidden", backgroundColor: "var(--background-color)" }}>{children}</CardContent>
				</Card>
			)}
		</div>
	);
}
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
export function ConfirmationDialog({ open, handleClose, handleSubmit, title = "Are you sure?", children, submitText = "Delete", cancelText = "Cancel", isSubmitDisabled = false, noBtn = false }) {
	return (
		<MuiDialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-describedby="confirmation-dialog-description"
			PaperProps={{
				sx: {
					position: "fixed",
					bottom: 20,
					left: "50%",
					transform: "translateX(-50%)",
					m: 0,
					borderRadius: 2,
					backgroundColor: "var(--model-bg-color)",
					color: "var(--text-color)",
					width: 320,
					fontSize: "0.85rem",
				},
			}}
		>
			<DialogTitle sx={{ px: 2, pb: 0, pt: 1, fontSize: "1.2rem", display: "flex", justifyContent: "center" }}>{title}</DialogTitle>
			<DialogContent sx={{ px: 2, pb: 0 }}>{children}</DialogContent>

			{!noBtn && (
				<DialogActions sx={{ px: 2, pb: 1, display: "flex", justifyContent: "center" }}>
					<Button autoFocus onClick={handleClose} text="Cancel" style={buttonClasses.lynkitOrangeEmpty} />
					<Button autoFocus onClick={handleSubmit} text={submitText} style={buttonClasses.lynkitOrangeFill} disabled={isSubmitDisabled} />
				</DialogActions>
			)}
		</MuiDialog>
	);
}
function Dialog({ open, handleClose, handleCancel, handleSubmit, title, size = "sm", children, noBtn = false, hideSubmitButton = false, isSubmitDisabled = false, CancelText = "Cancel", SubmitText = "Submit", minHeight, hideCloseIcon = false, noCancelBtn = false, paperSx = {}, contentSx }) {
	return (
		<MuiDialog fullWidth maxWidth={size} onClose={handleClose} aria-labelledby="dialog-title" open={open} PaperProps={{sx: {minHeight: minHeight || "auto", backgroundColor: "var(--model-bg-color)", color: "var(--text-color)", ...paperSx }}}>
			<DialogTitle sx={{ m: 0, p: 2, backgroundColor: "var(--model-bg-color)", color: "var(--text-color)" }} id="dialog-title">
				{title}
			</DialogTitle>
			{hideCloseIcon ? null : (
			<IconButton
				aria-label="close"
				onClick={handleClose}
				sx={{
					position: "absolute",
					right: 8,
					top: 8,
					color: "rgb(158, 158, 158)",
				}}
			>
				<CloseIcon />
			</IconButton>
			)}
			<DialogContent dividers sx={{ backgroundColor: "var(--model-bg-color)", color: "var(--text-color)", maxHeight: "65vh", ...contentSx }}>
				{children}
			</DialogContent>
			{noBtn ? null : (
				<DialogActions sx={{ backgroundColor: "var(--model-bg-color)", color: "var(--text-color)" }}>
					{noCancelBtn ? null : <Button autoFocus onClick={handleCancel ? handleCancel : handleClose} text={CancelText} style={{ ...buttonClasses.lynkitOrangeEmpty, width: "fitContent" }} />}
					{hideSubmitButton ? null : <Button autoFocus onClick={handleSubmit} text={SubmitText} style={{ ...buttonClasses.lynkitOrangeFill, width: "fitContent" }} disabled={isSubmitDisabled} />}
				</DialogActions>
			)}
		</MuiDialog>
	);
}
export function Drawer({ open, onClose, children, anchor = "right" }) {
	return (
		<MuiDrawer
			open={open}
			onClose={onClose}
			anchor={anchor}
			// variant="persistent"
			// sx={{
			// 	position: "relative", //imp
			// 	width: 240, //drawer width
			// 	"& .MuiDrawer-paper": {
			// 		width: 240, //drawer width
			// 		position: "absolute", //imp
			// 		transition: "none !important",
			// 	},
			// }}
		>
			{children}
		</MuiDrawer>
	);
}
const AccordionWrapper = ({ title, children, isOpenAcc = false }) => {
	const [expanded, setExpanded] = useState(isOpenAcc);

	const handleChange = (event, isExpanded) => {
		// settings usecase : there is input on the accordion title, doing actions to those inputs should not open/close the accordion
		if (event.target.type == undefined) setExpanded(isExpanded);
	};
	return (
		<Accordion
			expanded={expanded}
			onChange={handleChange}
			sx={{
				backgroundColor: "var(--table-body-bg-color)",
				color: "var(--text-color)",
				border: "1px solid var(--input-border-color)",
				mb: "18px",
				borderRadius: "5px",
				boxShadow: "none",
				"&:before": {
					display: "none",
				},
				"& .MuiOutlinedInput-root": {
					backgroundColor: "var(--table-body-bg-color)",
					color: "var(--text-color)",
				},
				"& .MuiInputBase-root": {
					color: "var(--text-color)",
				},
				"& .MuiInputLabel-root": {
					color: "var(--gray-color)",
				},
				"& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
					color: "var(--text-color)",
				},
			}}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel-content"
				id="panel-header"
				data-testid={`accordion-summary-${title}`}
				sx={{
					color: "var(--text-color)",
					"& .MuiAccordionSummary-expandIconWrapper": {
						color: "var(--text-color)",
					},
				}}
			>
				{typeof title == "string" ? <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold", color: "var(--table-header-text-color)" }}>{title}</Typography> : title}
			</AccordionSummary>
			<AccordionDetails sx={{ backgroundColor: "var(--table-body-bg-color)", color: "var(--text-color)" }} data-testid={`accordion-details-${title}`}>
				<Typography component="div">{expanded ? children : null}</Typography>
			</AccordionDetails>
		</Accordion>
	);
};

function Dropdown({
	id = "",
	name = "",
	value = null,
	options,
	onInputChange,
	onChange,
	handleCustomKeyDown,
	label,
	dataTestId = "",
	disabled = false,
	getOptionDisabled,
	error = "",
	required = false,
	multiple = false,
	readonly = false,
	inputRef = null,
	openOnFocus = false,
	enableCustomValue = false,
	validateValue,  //validate entring new value in dropdown
	helperText = "",
	disableClearable = false,
	groupBy = null,
	disableCloseOnSelect = false,
	clearOnBlur = true,
	loading = false,
	onClose,
}) {
	const [dropdownOptions, setDropdownOptions] = useState(options);
	const [inputValue, setInputValue] = useState('');
	const handleKeyDown = (event) => {
		// console.log("handleKeyDown=========================>", event);
		if (event.key === "Enter" && event.target.value) {
			const isValid = validateValue ? validateValue(event.target.value) : true;
			if(!isValid) {
				toastMessage(false, `Please enter valid input for ${label}`)
				return;
			}
			const newOption = { label: event.target.value, value: event.target.value };
			if (!dropdownOptions.some((option) => option.value === newOption.value)) {
				setDropdownOptions([...dropdownOptions, newOption]);
				if (multiple) {
					onChange([...(Array.isArray(value) ? value : []), newOption], name);
				} else {
					onChange(newOption, name);
				}
			}
			setInputValue('');
			handleCustomKeyDown ? handleCustomKeyDown(event) : null;
		}
	};
	const handleCustomKeyDownWrapper = enableCustomValue ? handleKeyDown : () => {};
	return (
		<FormControl variant="outlined" size="small" fullWidth>
			<ThemeProvider theme={autocompleteTheme}>
				<Autocomplete
					id={id}
					size="small"
					data-testid={dataTestId}
					sx={{
						"& fieldset": { borderRadius: "12px" },
						"& .MuiChip-root": {
							height: "auto!important",
						},
						"& .MuiChip-label": {
							overflow: "visible!important",
							textOverflow: "initial!important",
							whiteSpace: "normal!important",
							wordWrap: "break-word!important",
						},
					}}
					options={enableCustomValue ? dropdownOptions : options}
					name={name}
					onChange={(e, newVal) => onChange(newVal, name)}
					inputValue={inputValue}
					clearOnBlur={clearOnBlur}
					onInputChange={(e, newInputValue, reason) => {
						setInputValue(newInputValue);
						if (e?.type == "change" || (reason == "reset" && newInputValue == "")) {
							onInputChange && onInputChange({ target: { value: newInputValue } });
						}
						if (e?.type == "click" || (reason == "reset" && newInputValue !== "" && newInputValue !== inputValue)) {
							onInputChange && onInputChange({ target: { value: newInputValue } });
						}
					}}
					onClose={(event, reason) => {
						onClose && onClose(event, reason, inputValue);
					}}
					disabled={disabled}
					readOnly={readonly}
					error={error}
					onKeyDown={handleCustomKeyDownWrapper}
					renderInput={(params) => (
						<TextField
							sx={{
								...inputClasses.textField,
							}}
							{...params}
							label={label}
							required={required}
							error={!!error}
							helperText={error || ""}
							inputRef={inputRef}
						/>
					)}
					renderOption={(props, option) => {
						return (
							<li
								{...props}
								key={`${props.key}-${props.id}-${props["data-option-index"]}`}
								style={{
									color: option.isCreateOption ? "#ff7200" : "var(--text-color)",
									fontSize: "14px",
								}}
							>
								{option.label}
							</li>
						);
					}}
					value={value}
					getOptionLabel={(option) => option?.label || ""}
					getOptionDisabled={getOptionDisabled}
					isOptionEqualToValue={(option, value) => {
						return (option?.value == "" && value == "") || option?.value == value?.value;
					}}
					multiple={multiple}
					openOnFocus={openOnFocus}
					loading={loading}
					loadingText="Loading..."
					disableClearable={disableClearable}
					groupBy={groupBy}
					disableCloseOnSelect={disableCloseOnSelect}
					renderTags={(value, getTagProps) => {
						const numTags = value.length;
						const limitTags = 2;

						return (
							<>
								{value.slice(0, limitTags).map((option, index) => (
									<Chip {...getTagProps({ index })} key={index} label={option.label} />
								))}

								{numTags > limitTags && <span style={{ color: "var(--text-color)" }}>{` +${numTags - limitTags} more`}</span>}
							</>
						);
					}}
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</ThemeProvider>
		</FormControl>
	);
}

function GenericTable({ sortheader, header, rows, pageCount, TableData, pageNo, onPageChange, onPageSizeChange, limit, isLoading, IsScroll, openRows, openRowsData, IsTableBodyScroll = false, IsTableBodyScrollStyle= {} }) {
	// console.log({header,
	// 	rows,
	// 	pageCount,
	// 	pageNo,
	// 	onPageChange,
	// 	onPageSizeChange,
	// 	limit,})
	return (
		<TableMui
			sortheader={sortheader}
			header={header}
			rows={rows}
			TableData={TableData}
			pageCount={pageCount}
			pageNumber={pageNo}
			handleChangePage={onPageChange}
			handleChangeRowsPerPage={onPageSizeChange}
			rowsPerPage={limit}
			isLoading={isLoading}
			IsScroll={IsScroll}
			openRows={openRows}
			openRowsData={openRowsData}
			IsTableBodyScroll={IsTableBodyScroll}
			IsTableBodyScrollStyle={IsTableBodyScrollStyle}
		/>
	);
}

function Input({
	id = "",
	name,
	value,
	onChange,
	type = "text",
	label = "",
	placeholder = "",
	min = "",
	max = "",
	step = "",
	readOnly = false,
	disabled = false,
	required = false,
	children,
	adornment = {
		is: false,
	},
	error = "",
	sx = {},
	regex = "",
	onKeyDown = () => {},
	multiline = false,
	maxLength,
}) {
	return (
		<TextField
			size="small"
			variant="outlined"
			sx={{ ...inputClasses.textField, ...sx }}
			InputProps={{
				sx: { ...inputClasses.textField, ...sx },
				endAdornment: adornment?.is ? (
					<InputAdornment position="end">
						<IconButton onClick={adornment.onClick} edge="end" sx={{ color: "var(--gray-color)" }}>
							{adornmentIcon[adornment.type]}
						</IconButton>
					</InputAdornment>
				) : null,
				readOnly: readOnly,
				// min :{min}
			}}
			type={type}
			name={name}
			value={value}
			onChange={(e) => {
				onChange(e);
			}}
			onWheel={(e) => type === "number" && e.target.blur()}   // prevent scroll change
			label={label}
			placeholder={placeholder}
			multiline={multiline}
			required={required}
			id={id}
			disabled={disabled}
			error={!!error}
			helperText={error || ""}
			inputProps={{ regex, min, max, maxLength }}
			onKeyDown={onKeyDown}
		/>
	);
}

const PhoneNumberTextField = React.forwardRef(function PhoneNumberTextField(props, ref) {
	return <TextField {...props} inputRef={ref} size="small" fullWidth variant="outlined" sx={{ ...inputClasses.textField, "& fieldset": { borderRadius: "12px" } }} />;
});

function normalizeCountryCode(countryCode) {
	if (typeof countryCode !== "string") return undefined;

	const normalizedCode = countryCode
		.replace(/&#x([0-9a-f]+);/gi, (_, value) => String.fromCodePoint(parseInt(value, 16)))
		.replace(/&#(\d+);/g, (_, value) => String.fromCodePoint(parseInt(value, 10)))
		.trim()
		.toUpperCase();

	return isSupportedCountry(normalizedCode) ? normalizedCode : undefined;
}

function PhoneNumberInput({
	name = "",
	value = "",
	onChange,
	countryCode,
	label = "Mobile",
	placeholder = "Enter Mobile",
	disabled = false,
	readOnly = false,
	error = "",
	required = false,
}) {
	const normalizedCountryCode = normalizeCountryCode(countryCode);

	return (
		<PhoneInput
			country={normalizedCountryCode}
			international
			withCountryCallingCode
			value={value || undefined}
			onChange={(phoneNumber) => onChange(phoneNumber || "", name)}
			inputComponent={PhoneNumberTextField}
			label={label}
			placeholder={placeholder}
			name={name}
			disabled={disabled}
			readOnly={readOnly}
			error={!!error}
			helperText={error || ""}
			required={required}
		/>
	);
}

function Loader({ size = "", height = "", isCircle = false }) {
	return (
		<div className="loaderContainer" style={{ height }}>
			{isCircle ? <i className="fa fa-spinner fa-spin spinner" style={{ fontSize: size, color: "var(--primary-color)" }}></i> : <img src={loader} alt="" />}
		</div>
	);
}
export function Radio({ label, options = [], onChange, value, name, row }) {
	return (
		<FormControl>
			{label ? <FormLabel>{label}</FormLabel> : null}
			<RadioGroup value={value} onChange={onChange} name={name} row={row}>
				{options.map((_, i) => {
					return (
						<FormControlLabel
							key={i}
							label={<Typography sx={{ fontSize: "13px" }}>{_.label}</Typography>}
							control={<MuiRadio value={_.value} size="small" sx={{ "&.Mui-checked": { color: theme.themeOrange } }} />}
						/>
					);
				})}
			</RadioGroup>
		</FormControl>
	);
}
function SearchDropdown({
	id = "",
	name = "",
	value = "",
	preSelectedOption = null,
	options = [],
	onChange,
	onDropdownChange,
	onhandleClear,
	type = "text",
	label,
	placeholder = "",
	dataTestId = "",
	disabled = false,
	error = "",
	required = false,
	multiple = false,
	Debounce = false,
	textBorderRadius = "1px 12px 12px 1px",
	selectBorderRadius = "12px 1px 1px 12px",
	adornment = {
		is: false,
	},
}) {
	const [selectedOption, setselectedOption] = useState(preSelectedOption);
	// let selectedOption = { }
	// const dropdown = options && options.length > 0 && options.map((ele) => ({'label': capitalizeSentence(ele), 'value': ele }))
	// options = options.map( x => ({"label": x, "value": x}))
	const onhandleDropdown = (newVal, name) => {
		// console.log("selectdropdown", newVal);
		// selectedOption = newVal
		setselectedOption(newVal);
		if (onDropdownChange) {
			onDropdownChange(newVal, name);
		}
		if (newVal === null) {
			onhandleClear();
		}
	};
	const onhandleInput = (value) => {
		if (selectedOption && selectedOption.value != "" && Debounce === true) {
			debounce(onChange(value, selectedOption.value), 500);
		} else {
			onChange(value, selectedOption?.value);
		}
	};
	return (
		<div style={{ display: "flex", width: "100%" }}>
			<div style={{ display: "flex", width: "50%" }}>
				<FormControl variant="outlined" size="small" fullWidth>
					<ThemeProvider theme={autocompleteTheme}>
						<Autocomplete
							size="small"
							data-testid={dataTestId}
							sx={{ "& fieldset": { borderRadius: selectBorderRadius } }}
							options={options.length > 0 ? options : []}
							// name={name}
							onChange={(e, newVal) => onhandleDropdown(newVal, name)}
							disabled={disabled}
							error={error}
							renderInput={(params) => (
								<TextField
									sx={{
										...inputClasses.textField,
									}}
									{...params}
									label={label}
									required={required}
									error={!!error}
									helperText={error || ""}
								/>
							)}
							renderOption={(props, option) => {
								return (
									<li
										{...props}
										key={`${props.key}-${props.id}-${props["data-option-index"]}`}
										style={{
											color: option.isCreateOption ? "#ff7200" : "var(--text-color)",
											fontSize: "14px",
										}}
									>
										{option.label}
									</li>
								);
							}}
							value={selectedOption}
							isOptionEqualToValue={(option, value) => {
								return (option?.value == "" && value == "") || option?.value == value?.value || option === value;
							}}
							multiple={multiple}
						/>
					</ThemeProvider>
				</FormControl>
			</div>
			<div style={{ display: "flex", width: "50%" }}>
				<FormControl variant="outlined" size="small" fullWidth>
					<TextField
						size="small"
						variant="outlined"
						sx={{ ...inputClasses.textField }}
						InputProps={{
							sx: { ...inputClasses.textField, borderRadius: textBorderRadius },
							endAdornment: adornment?.is ? (
								<InputAdornment position="end">
									<IconButton
										aria-label={type === "password" ? "toggle password visibility" : "clear search input"}
										onClick={adornment.onClick}
										// onMouseDown={handleMouseDownPassword}
										edge="end"
									>
										{adornmentIcon[adornment.type]}
									</IconButton>
								</InputAdornment>
							) : null,
						}}
						type={type}
						// name={name}
						value={value[selectedOption?.value] ? value[selectedOption?.value] : ""}
						onChange={(e) => onhandleInput(e.target.value)}
						// label={label}
						placeholder={placeholder}
						required={required}
						id={id}
						disabled={disabled}
						error={!!error}
						helperText={error || ""}
					/>
				</FormControl>
			</div>
		</div>
	);
}
function SearchInput({ onChange, value = "", placeholder }) {
	return (
		<FormControl fullWidth variant="outlined" size="small" sx={{ ...inputClasses.themeBoundary }}>
			<OutlinedInput
				sx={{
					fontSize: "12px",
					...inputClasses.themeBoundary,
					"& input::placeholder": {
						fontSize: "12px",
					},
				}}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				endAdornment={
					<InputAdornment position="end">
						<Search fontSize="small" />
					</InputAdornment>
				}
			/>
		</FormControl>
	);
}
export {
	PopOver,
	ActionMenu,
	Button,
	Checkbox,
	DataNotFound,
	DateTimePicker,
	DatePicker,
	DatePickerOfMonth,
	DetailCard,
	Dialog,
	AccordionWrapper,
	Dropdown,
	GenericTable,
	Input,
	PhoneNumberInput,
	Loader,
	SearchDropdown,
	AddRemove,
	TimePicker,
	Switcher,
};

function generateDetailRows(data) {
	return data?.map(({ label, value }, i) => {
		return (
			<div className="detail_row" key={i}>
				<div className="detail_row_title">{label}</div>
				<div className="detail_row_value">{value}</div>
			</div>
		);
	});
}

const tCell = (text = "-", color = "", cursor = "", onClick = () => {}, i = -1, className = "") => {
	return (
		<Typography
			className={className}
			sx={{
				...textClasses.t13n,
				textAlign: "center",
				color,
				cursor,
				minWidth: "7rem",
				maxWidth: "20rem",
				wordWrap: "break-word",
			}}
			onClick={(e) => onClick(e, i)}
		>
			{typeof text == "object" ? text : text.toString()}
			{text == "Action" ? <ArrowDownIcon /> : null}
		</Typography>
	);
};

function toastMessage(isSuccess, message, options = {}) {
	if (isSuccess === "loading") {
		return toast.loading(message, options);
	}
	return isSuccess ? toast.success(message, options) : toast.error(message || "Something went wrong", options);
}

function dismissToast(id) {
	return toast.dismiss(id);
}

export { generateDetailRows, tCell, toastMessage, dismissToast };

export default function UploadFileButton({
	onChange,
	onChangeClear,
	color = "var(--primary-color)",
	bgColor = "transparent",
	disabled = false,
	opacity = "1",
	allowedExtensions,
	fileName,
	// Whether the name shown is an in-progress, cancellable selection (shows "X" -> onChangeClear)
	// vs. just informational display of the currently active file (clicking opens the picker instead).
	clearable = true,
	border = "1px solid  var(--primary-color)",
	width = "100%",
	icon = <UploadIcon />,
	buttonText = "Upload a file",
	// Falls back to `buttonText`; pass it when several upload buttons share short visible text
	// ("Upload", "Replace") and each still needs a distinct accessible name.
	ariaLabel = "",
	asterisk = "",
	error = "",
}) {
	const showClear = !!fileName && clearable;
	const handleClear = () => {
        if (disabled) return;
		onChangeClear();
	};

	const handleClick = () => {
        if (disabled) return;
		fakeFileInput((fileData) => {
			onChange(fileData.get("file"), fileData);
		}, allowedExtensions);
	};
	// Truncate fileName if it's too long
	const truncatedFileName = fileName && fileName.length > 25 ? `${fileName.slice(0, 25)}...` : fileName;
	return (
		<div className="upload-file-button-2-container">
			<button
				className={`btn ${asterisk} cursor-pointer`}
				type="button" disabled={disabled}
				style={{
					backgroundColor: bgColor,
					border: border,
					color: color,
					borderRadius: "10px",
					width,
					opacity,
					fontSize: "var(--project-large-font)",
				}}
				onClick={handleClick}
                aria-label={ariaLabel || buttonText}
			>
				<span style={{ maxWidth: "200px", wordWrap: "break-word" }}>
					{/* {fileName || buttonText} */}
					{fileName ? truncatedFileName : buttonText}
				</span>
				<div
					style={{ zIndex: `${fileName ? 50 : 0}` }}
					onClick={(e) => {
						e.stopPropagation();
						showClear ? handleClear() : handleClick();
					}}
				>
					{showClear ? <CloseIcon /> : icon}
				</div>
			</button>
			<span style={{ color: "var(--red-color)", fontSize: "12px" }}>{error}</span>
		</div>
	);
}

export function ColorPicker({ onChange, name = "favcolor", value, disabled = false }) {
	const [color, setColor] = useState("#ff7200");

	const handleColorChange = (event) => {
        if (disabled) return;
		setColor(event.target.value);
		onChange(event.target.value, event);
	};
	return (
		<>
			<div className="color-picker-container">
				<span className="input-text">{value || color}</span>
				<div className="color-picker-btn-container">
					<button className="btn" type="button" disabled={disabled}>
						<img style={{ width: "25px", height: "25px" }} src={colorPicker} alt="color-picker" />
					</button>
					<input disabled={disabled} type="color" id="favcolor" name={name} value={value || color} onChange={handleColorChange} />
				</div>
			</div>
		</>
	);
}

function AddRemove({ list = [], filterMethod, onAdd, onRemove, index, outerIndex, maxAddLimit=null }) {
	const disableAdd = maxAddLimit ? (list.length < maxAddLimit ? list.filter(filterMethod).length >= 2 : true) : list.filter(filterMethod).length >= 2;
	const length = list.length;
	return (
		<div className="d-flex c_gap_h">
			{length > 1 ? (
				<div className="remove_circ_md" onClick={() => onRemove(index, outerIndex)}>
					<i className="fa fa-times-circle"></i>
				</div>
			) : null}
			{outerIndex == length - 1 ? (
				<div
					className="add_circ_md"
					onClick={(e) => {
						if (!disableAdd) onAdd(index, outerIndex);
						return;
					}}
					style={{
						cursor: disableAdd ? "not-allowed" : "pointer",
					}}
				>
					<i className="fa fa-plus-circle"></i>
				</div>
			) : null}
		</div>
	);
}

const ITEM_TYPE = "COLUMN";
const DraggableItem = ({ column, index, moveItem, toggleSelect }) => {
	const ref = useRef(null);

	const [, drop] = useDrop({
		accept: ITEM_TYPE,
		hover(item, monitor) {
			if (!ref.current) return;
			const dragIndex = item.index;
			const hoverIndex = index;
			if (dragIndex === hoverIndex) return;
			const hoverBoundingRect = ref.current.getBoundingClientRect();
			const clientOffset = monitor.getClientOffset();
			if (!clientOffset) return;

			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;

			if ((dragIndex < hoverIndex && hoverClientY > hoverMiddleY) || (dragIndex > hoverIndex && hoverClientY < hoverMiddleY)) {
				moveItem(item.key, column.key);
				item.index = hoverIndex;
			}
		},
	});

	const [{ isDragging }, drag] = useDrag({
		type: ITEM_TYPE,
		item: { key: column.key, index },
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	drag(drop(ref));

	return (
		<div className="item-row" ref={ref}>
			<input type="checkbox" checked={column.showOnList} onChange={() => toggleSelect(column.key)} onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()} />
			<span className="item-label">{column.label}</span>
			<span className="drag-icon" onMouseDown={(e) => e.stopPropagation()}>
				<DragIndicatorIcon style={{ fill: "var(--text-color)" }} />
			</span>
		</div>
	);
};

export const TableColumnCustomizer = ({ tableColumList, onApply }) => {
	const [columns, setColumns] = useState(() => (Array.isArray(tableColumList) ? tableColumList.map((col) => ({ ...col })) : []));
	const [search, setSearch] = useState("");
	const [popoverOpen, setPopoverOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);

	useEffect(() => {
		if (Array.isArray(tableColumList)) {
			setColumns(tableColumList.map((col) => ({ ...col })));
		}
	}, [tableColumList]);

	const moveItem = (fromKey, toKey) => {
		const fromIndex = columns.findIndex((c) => c.key === fromKey);
		const toIndex = columns.findIndex((c) => c.key === toKey);
		if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

		const updated = [...columns];
		const [movedItem] = updated.splice(fromIndex, 1);
		updated.splice(toIndex, 0, movedItem);
		const reordered = updated.map((item, index) => ({
			...item,
			sequenceNo: index + 1,
		}));
		setColumns(reordered);
	};

	const toggleSelect = (key) => {
		setColumns((prev) => prev.map((c) => (c.key === key ? { ...c, showOnList: !c.showOnList } : c)));
	};

	const toggleSelectAll = () => {
		const allSelected = columns.every((c) => c.showOnList);
		setColumns(columns.map((c) => ({ ...c, showOnList: !allSelected })));
	};

	const filtered = columns.filter((col) => col.label.toLowerCase().includes(search.toLowerCase()));
	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
		setPopoverOpen(true);
	};

	const handleClose = () => {
		setPopoverOpen(false);
	};
	return (
		<div className="customizer-container">
			<Button className="customizer-header" onClick={handleClick} text="Customize Table" style={{ ...buttonClasses.lynkitOrangeFill, width: "140px" }} />
			<PopOver open={popoverOpen} anchorEl={anchorEl} onClose={handleClose} title={"Customize your table"} titleFontSize={"1rem"} contentFontSize={"0.8rem"}>
				<input type="text" placeholder="Search" className="search-box" value={search} onChange={(e) => setSearch(e.target.value)} />
				<div className="item-row">
					<input type="checkbox" checked={columns?.length > 0 && columns.every((c) => c.showOnList)} onChange={toggleSelectAll} />
					<span className="item-label">Select All</span>
				</div>
				<DndProvider backend={HTML5Backend}>
					<div className="items-container">
						{filtered.map((col, idx) => (
							<DraggableItem key={col.key} column={col} index={idx} moveItem={moveItem} toggleSelect={toggleSelect} />
						))}
					</div>
				</DndProvider>
				<div className="buttons-row">
					<Button
						className="btn-apply"
						text="Apply"
						onClick={() => {
							onApply(columns.filter((c) => c.showOnList)), handleClose();
						}}
						style={{ ...buttonClasses.lynkitOrangeFill, width: "65px" }}
					/>
					<Button
						className="btn-close"
						text="Close"
						onClick={() => {
							setColumns(columns.map((c) => ({ ...c, showOnList: false }))), handleClose();
						}}
						style={{ ...buttonClasses.lynkitOrangeEmpty, width: "65px" }}
					/>
				</div>
			</PopOver>
		</div>
	);
};
